import { AwallComponentEvent } from '../../../models/awallComponentEvent';
import { ComponentEvent } from '../../../models/enums/componentEvent';
import { CommunicationService } from '../../../services/communication.service';
import { DynamicElementService } from '../../../services/dynamicElement.service';
import { WidgetType } from '../../../util/WidgetType';
import { StateTransitionHelperClass } from '../../widget-wrapper/StateTransitionHelper';
import { WidgetWrapperComponent } from '../../widget-wrapper/widget-wrapper.component';
import { TOOLBAR_COMPONENT_ID } from '../const';

export class ToolbarStateTransitionHelperClass extends StateTransitionHelperClass {
  protected sendRemoveWrapperEvent(communicationService: CommunicationService, { widgetName }: WidgetWrapperComponent) {
    const data = { widgetName };
    const dockEvent = new AwallComponentEvent(ComponentEvent.TOOLBAR_REMOVE_WRAPPER, data);
    communicationService.sendData(this.receiver, dockEvent);
  }

  protected sendInsertWrapperEvent(
    communicationService: CommunicationService,
    { widgetName, wrapperComponentRef }: WidgetWrapperComponent,
  ) {
    const data = { widgetName, wrapperComponentRef };
    const dockEvent = new AwallComponentEvent(ComponentEvent.TOOLBAR_INSERT_WRAPPER, data);
    communicationService.sendData(this.receiver, dockEvent);
  }

  protected replaceWithPlaceholder(wrapper: WidgetWrapperComponent) {
    // noop
  }

  protected updateSpacers(communicationService: CommunicationService) {
    // noop
  }

  protected addPlaceholder(wrapper: WidgetWrapperComponent): void {
    // noop
  }

  protected removePlaceholder(wrapper: WidgetWrapperComponent): void {
    // noop
  }
}

export const ToolbarStateTransitionHelper = new ToolbarStateTransitionHelperClass(TOOLBAR_COMPONENT_ID);
